<template>
  <div class="fixed bottom-0 left-0 right-0 flex flex-col  assistant-wrap">
    <div class="flex flex-row items-center pl-4 pr-4 bg-white gap-3 " style="height:68px;">
      <VanField v-model="inputContent" class="flex-1" placeholder="Enter" @keyup.enter="onEnter($event)"/>
      <van-image @click="onShowToolbar" :src="require('@/assets/icons/v2/icon_add_media.png')" width="40"
          height="40"/>
    </div>

    <div class="flex flex-row items-center justify-between pl-4 pr-4">
      <div v-for="(item,index) in functions">
        <template v-if="index === 2">

          <!-- 自定义文件选择按钮 -->
          <label for="fileInput" class="custom-file-input" @click="item.handler">
            <span class="custom-file-icon"></span>
          </label>
          <input type="file" accept="image/*" capture="camera" ref="cameraInput">
        </template>
        <template v-else-if="index === 3">

          <!-- 自定义文件选择按钮 -->
          <label for="fileInput" class="custom-file-input" @click="item.handler">
            <span class="custom-file-icon2"></span>
          </label>
          <input type="file" accept="video/*" capture="camcorder" ref="videoInput">
        </template>

        <van-image v-else width="25" height="25" :src="item.icon" @click="item.handler"/>
      </div>

    </div>

  </div>
</template>

<script>
import assistant from "@/api/assistant";
import { Toast } from "vant";
import user from "@/api/user";
import { b64toBlob, openExternalUrl } from "@/util/utils";
import log from "@/util/log"

export default {
  name: "AssistantBottom",
  props: {
    showMediaToolbar: false
  },
  data() {
    return {
      inputContent: "",
      functions: [
        {
          icon: require("@/assets/icons/v2/icon_assistant_email.png"),
          handler: this.mailTo
        },
        {
          icon: require("@/assets/icons/v2/icon_assistant_photo.svg"),
          handler: () => this.selectImage(2)
        },
        {
          icon: require("@/assets/icons/v2/icon_assistant_camera.svg"),
          handler: this.takePhoto
        },
        // {
        //   icon: require("@/assets/icons/v2/icon_assistant_video.png"),
        //   handler: this.takeVideo
        // }
      ]
    };
  },
  methods: {
    onShowToolbar() {
      this.$emit("onShowToolBar");
    },
    async onEnter(e) {
      if (!this.inputContent) {
        return;
      }
      const data = await assistant.sendMessage({
        content: this.inputContent,
        type: 1
      });
      this.inputContent = "";
      this.$emit("onChatChange", data);

    },

    mailTo() {
      openExternalUrl("mailto://info@ikusher.com")

    },

    selectImage(type) {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = type === 2 ? "image/*" : "video/*";
      input.onchange = async e => {
        const file = e.target.files[0];
        if (file) {
          try {
            const selectedImage = URL.createObjectURL(file);
            const formData = new FormData();
            formData.append("file", file);
            Toast.loading("Uploading");
            const data = await user.uploadFile(formData);
            const resp = await assistant.sendMessage({
              type: type,
              content: data
            });
            this.$emit("onChatChange", resp);
            Toast.clear();
          } catch (err) {
            Toast.fail("Upload avatar fail!" + err);
          } finally {
          }
        }
      };
      input.click();
    },

    takePhoto() {
      const input = this.$refs.cameraInput[0];
      input.onchange = async e => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = async () => {
          log(reader.result);
          const base64Data = reader.result.split(",")[1]; // 去除 data:image/jpeg;base64, 前缀
          const blob = b64toBlob(base64Data, "image/jpeg");
          const file = new File([blob], "filename.jpg", { type: "image/jpeg" });
          if (file) {
            try {
              const selectedImage = URL.createObjectURL(file);
              const formData = new FormData();
              formData.append("file", file);
              Toast.loading("Uploading");
              const data = await user.uploadFile(formData);
              const resp = await assistant.sendMessage({
                type: 2,
                content: data
              });
              this.$emit("onChatChange", resp);
              Toast.clear();
            } catch (err) {
              log(err);
              Toast.fail("Upload avatar fail!" + err);
            } finally {
            }
          }
        };

        reader.readAsDataURL(file);
      };
      input.click();
      // <input type="file" accept="image/*" capture="camera" id="cameraInput">
    },
    takeVideo() {
      const input = this.$refs.videoInput[0];
      input.onchange = async e => {
        const file = e.target.files[0];
        if (file) {
          try {
            const selectedImage = URL.createObjectURL(file);
            const formData = new FormData();
            formData.append("file", file);
            Toast.loading("Uploading");
            const data = await user.uploadFile(formData);
            const resp = await assistant.sendMessage({
              type: 3,
              content: data
            });
            this.$emit("onChatChange", resp);
            Toast.clear();
          } catch (err) {
            log(err);
            Toast.fail("Upload avatar fail!" + err);
          } finally {
          }
        }
      };
      input.click();
      // <input type="file" accept="image/*" capture="camera" id="cameraInput">
    }
  },
  computed: {},
  mounted() {

  }
};
</script>

<style scoped lang="less">
.assistant-wrap {
  background: white;
  transition: height 0.2s ease-in;
  height: calc(var(--bottomHeight) + env(safe-area-inset-bottom));
}

::v-deep .van-cell {
  padding: 10px 0;

  .van-field__control {
    border-radius: 12px;
    border: 1px #e8e8e8 solid;
    padding: 0 16px;
  }
  &:after {
    border: none;
  }
}

/* 隐藏原生的文件选择按钮 */
input[type="file"] {
  display: none;
}

/* 自定义样式的文件选择按钮 */
.custom-file-input {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* 图标样式 */
.custom-file-icon {
  display: inline-block;
  width: 25px;
  height: 25px;
  background-image: url('../../assets/icons/v2/icon_assistant_camera.png'); /* 替换为你的图标路径 */
  background-size: cover;
}
/* 图标样式 */
.custom-file-icon2 {
  display: inline-block;
  width: 25px;
  height: 25px;
  background-image: url('../../assets/icons/v2/icon_assistant_video.png'); /* 替换为你的图标路径 */
  background-size: cover;
}
</style>